import { Predicate, Type } from './types';

export const presets: Record<Type, Predicate> = {
    [Type.FREE]: ({ isValid, licenseType }) => isValid && /free/i.test(licenseType),
    [Type.TRIAL]: ({ isValid, licenseType }) => isValid && /trial/i.test(licenseType),
    [Type.PAID]: (item) => item.isValid && !presets.free(item) && !presets.trial(item)
};
